import React from 'react';
import { useTranslation } from 'react-i18next';

function TiposDeViajeSection() {
  const { t } = useTranslation();
  return (
    <>
      <div className="section-header-modern">
        <h2>{t('tipos_viaje')}</h2>
        <p>{t('tipos_viaje_desc')}</p>
      </div>
      <div className="grid-4-cols">
        <div className="card-modern">
          <div style={{ fontSize: 48, marginBottom: 12 }}>🌍</div>
          <h3>{t('turismo_clasico')}</h3>
          <p>{t('turismo_clasico_desc')}</p>
        </div>
        <div className="card-modern">
          <div style={{ fontSize: 48, marginBottom: 12 }}>🥾</div>
          <h3>{t('aventura')}</h3>
          <p>{t('aventura_desc')}</p>
        </div>
        <div className="card-modern">
          <div style={{ fontSize: 48, marginBottom: 12 }}>🍽️</div>
          <h3>{t('gastronomico')}</h3>
          <p>{t('gastronomico_desc')}</p>
        </div>
        <div className="card-modern">
          <div style={{ fontSize: 48, marginBottom: 12 }}>🌳</div>
          <h3>{t('naturaleza')}</h3>
          <p>{t('naturaleza_desc')}</p>
        </div>
      </div>
    </>
  );
}

export default TiposDeViajeSection;
